import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '@cian/ui-kit';
import { clearNotifications } from 'shared/slices';
import { selectNotifications } from 'shared/selectors/notifications';

export function NotificationsContainer() {
  const dispatch = useDispatch();
  const toastApi = useToast();
  const notifications = useSelector(selectNotifications);

  useEffect(() => {
    if (!notifications.length) {
      return;
    }

    notifications.forEach(({ type, text }) => {
      toastApi.open({ type, text });
    });

    dispatch(clearNotifications());
  }, [notifications, toastApi, dispatch]);

  return null;
}
